module.exports = __webpack_public_path__ + "static/media/rloc.aaac9b47.png";